import { gql } from '@apollo/client';

const GET_QRCODE = gql`
  query getReturnedOrder($orderId: String, $email: String, $count: Int) {
    returnedOrder(orderId: $orderId, email: $email, count: $count) {
      encodedOrderDetails
      returnMethod {
        mapUrl
        children {
          dropoffLocationsLink
        }
      }
      confirmationDetails {
        canShowQRCode
        isReadyToDisplay
        assetAvailable
      }
    }
  }
`;

export default GET_QRCODE;